import { Box, BoxProps, forwardRef } from '@chakra-ui/react'

export const Toolbar = forwardRef<BoxProps, 'div'>((props, ref) => (
  <Box ref={ref} background="gray.200" borderRadius="lg" px="4" py="2" {...props} />
))
